export default {
  async loadWorkspace (store, inactiveStatus) {
    try {
      const data = await this.$axios.$post('/workspace', inactiveStatus);
      store.commit('setWorkspaceArray', data);
    } catch (error) {
      if (error?.response?.status === 401) {
        this.$auth.logout();
        this.$router.push('/login');
      }
      throw (error);
    }
  },
};
